import { router as actionTypes } from '../constants/action-types';

export const change = result => {
  return { type: actionTypes.CHANGE, result };
}



// WEBPACK FOOTER //
// ./src/actions/router.js